type AnyFn = (...args: unknown[]) => unknown;
type MarkedValue = object | AnyFn;

const isMarkedValue = (v: unknown): v is MarkedValue =>
    !!v && (typeof v === "object" || typeof v === "function");

export const createErrorMarker = <TName extends string>(name: TName) => {
    const TAG: symbol = Symbol(name);

    const mark = <T>(e: T): T => {
        if (isMarkedValue(e)) {
            Object.defineProperty(e, TAG, {
                value: true,
                enumerable: false,
            });
        }
        return e;
    };

    const is = (e: unknown): boolean =>
        isMarkedValue(e) && !!(e as MarkedValue & Record<symbol, unknown>)[TAG];

    return { TAG, mark, is } as const;
};
